<form #form="ngForm" autocomplete="off" (submit)="saved.emit({ poll: poll })" class="d-flex flex-column flex-fill min-h-0 margin-top-20 gap-1" [ngClass]="styles.editPollForm">

	<ng-container>
		<div [ngClass]="styles.answersScrollArea">
			<vb-ui-form-group>
				<label for="epPollQuestion" #uiLabel class="type-bold">
					{{ 'Event_PollQuestionLabel' | translate }}
				</label>
				<input type="text" id="epPollQuestion" [placeholder]="'Event_PollQuestionPlaceHolder' | translate" [attr.aria-label]="'Event_PollQuestionPlaceHolder' | translate" name="epPollQuestion" #pQuestion="ngModel" [(ngModel)]="poll.question" autocomplete="off" required vbUiTextInput uiControl>
				@if (pQuestion.invalid) {
					<div role="alert" vbUiErrorMessage uiValidation>
						@if (pQuestion.errors.required) {
							{{ 'ThisFieldIsRequired' | translate }}
						}
					</div>
				}
			</vb-ui-form-group>

			<div layout class="align-items-center">
				<div class="type-bold">{{ 'Event_PollAnswersLabel' | translate }}</div>
				<div class="d-flex align-items-center margin-left-auto">
					<vb-toggle-button name="multipleChoice" [toggleId]="'multipleChoice'" [ariaLabel]="'Event_MultipleChoice' | translate" [(ngModel)]="poll.multipleChoice">
					</vb-toggle-button>
					<span [ngClass]="styles.multiChoice">
						{{ 'Event_MultipleChoice' | translate | vbTitleCase: context.titleCase }}
					</span>
				</div>
			</div>
			@for (answer of poll.answers; track $index) {
				<vb-ui-form-group>
					<input type="text" [id]="'answer' + ($index + 1)" [placeholder]="'Event_PollAnswerPlaceHolder' | translate : { '0': $index + 1 }" [attr.aria-label]="'Event_PollAnswerPlaceHolder' | translate : { '0': $index + 1 }" [name]="'answer' + ($index + 1)" [(ngModel)]="answer.text" autocomplete="off" vbUiTextInput uiControl>
				</vb-ui-form-group>
			}

			@if (form.touched && !minOneAnsProvided) {
				<div role="alert" vbUiErrorMessage uiValidation>
					{{ 'Event_PollAnswersRequiredError' | translate }}
				</div>
			}
			<div class="d-flex align-items-center justify-content-end gap-2">
				<span>{{ 'MaximumOf' | translate: { '0': maxAnswerCount } }}</span>
				<button [disabled]="poll.answers.length >= maxAnswerCount" type="button" vbBtnSecondary (click)="addAnswer()">
					{{ 'Event_AddPollResponse' | translate | vbTitleCase: context.titleCase }}
				</button>
			</div>
		</div>

		<div layout [ngClass]="styles.pollSubFooter" class="theme-primary-font-border-fade-50">
			<button type="button" vbBtnSecondary (click)="cancelled.emit()">
				{{ 'Cancel' | translate }}
			</button>
			<button type="submit" vbBtnPrimary [disabled]="!(formValid$ | async)">
				{{ (poll.isNew ? 'Add' : 'Save') | translate }}
			</button>
		</div>
	</ng-container>
</form>
